import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { name: "form" }
const _hoisted_4 = { class: "contain row" }
const _hoisted_5 = {
  key: 1,
  class: "page-container card col-md-8"
}
const _hoisted_6 = {
  key: 0,
  class: "row"
}
const _hoisted_7 = { class: "col-md-12 p-4" }
const _hoisted_8 = {
  key: 0,
  class: "row mb-3"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-3 required" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "col-form-label-title" }, "File ID:")
], -1)
const _hoisted_10 = { class: "col-md-6" }
const _hoisted_11 = { class: "row mb-3" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-3 required" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "col-form-label-title" }, "Company:")
], -1)
const _hoisted_13 = {
  key: 0,
  class: "col-md-6"
}
const _hoisted_14 = {
  key: 0,
  class: "d-flex align-items-center"
}
const _hoisted_15 = { class: "col-md-3" }
const _hoisted_16 = { class: "col-md-9" }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { class: "d-flex align-items-center col-md-12" }
const _hoisted_19 = { class: "col-md-3" }
const _hoisted_20 = { class: "col-md-9" }
const _hoisted_21 = {
  key: 1,
  class: "col-md-6"
}
const _hoisted_22 = { class: "row mb-3" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-3 required" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "col-form-label-title" }, "Balance Sheet Date:")
], -1)
const _hoisted_24 = { class: "col-md-6" }
const _hoisted_25 = { class: "row mb-3" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-3 required" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "col-form-label-title" }, "Currency:")
], -1)
const _hoisted_27 = { class: "col-md-6" }
const _hoisted_28 = {
  key: 0,
  class: "d-flex align-items-center"
}
const _hoisted_29 = { class: "col-md-3" }
const _hoisted_30 = { class: "col-md-9" }
const _hoisted_31 = { key: 1 }
const _hoisted_32 = { class: "d-flex align-items-center col-md-12" }
const _hoisted_33 = { class: "col-md-3" }
const _hoisted_34 = { class: "col-md-9" }
const _hoisted_35 = { class: "row mb-3" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-3 required" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "col-form-label-title" }, "Purpose:")
], -1)
const _hoisted_37 = { class: "col-md-6" }
const _hoisted_38 = { class: "row mb-3" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-3" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "col-form-label-title" }, "Is Consolidated:")
], -1)
const _hoisted_40 = {
  class: "col-md-6",
  style: {"padding":"0.5rem 1rem"}
}
const _hoisted_41 = {
  key: 1,
  class: "row mb-3"
}
const _hoisted_42 = { class: "col-md-12" }
const _hoisted_43 = { key: 2 }
const _hoisted_44 = { class: "row mb-3" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-3" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "col-form-label-title" }, "Created By:")
], -1)
const _hoisted_46 = { class: "col-md-3" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-3" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "col-form-label-title" }, "Created Date:")
], -1)
const _hoisted_48 = { class: "col-md-3" }
const _hoisted_49 = { class: "row mb-3" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-3" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "col-form-label-title" }, "Submitted By:")
], -1)
const _hoisted_51 = { class: "col-md-3" }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-3" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "col-form-label-title" }, "Submitted Date:")
], -1)
const _hoisted_53 = { class: "col-md-3" }
const _hoisted_54 = { class: "row mb-3" }
const _hoisted_55 = { class: "col-md-3" }
const _hoisted_56 = { class: "col-form-label-title" }
const _hoisted_57 = { class: "col-md-3" }
const _hoisted_58 = { class: "col-md-3" }
const _hoisted_59 = { class: "col-form-label-title" }
const _hoisted_60 = { class: "col-md-3" }
const _hoisted_61 = { class: "row mb-3" }
const _hoisted_62 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-3" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "col-form-label-title" }, "Status:")
], -1)
const _hoisted_63 = {
  class: "col-md-3",
  style: {"padding":"0.5rem 1rem"}
}
const _hoisted_64 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-3" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "col-form-label-title" }, "Template Version:")
], -1)
const _hoisted_65 = { class: "col-md-3" }
const _hoisted_66 = { class: "row mb-3" }
const _hoisted_67 = { class: "d-flex col-md-9" }
const _hoisted_68 = {
  key: 1,
  class: "p-1"
}
const _hoisted_69 = /*#__PURE__*/_createElementVNode("span", { class: "p-1" }, null, -1)
const _hoisted_70 = /*#__PURE__*/_createElementVNode("span", { class: "p-1" }, null, -1)
const _hoisted_71 = /*#__PURE__*/_createElementVNode("span", { class: "p-1" }, null, -1)
const _hoisted_72 = { key: 5 }
const _hoisted_73 = /*#__PURE__*/_createElementVNode("span", { class: "p-1" }, null, -1)
const _hoisted_74 = {
  key: 1,
  class: "p-1"
}
const _hoisted_75 = /*#__PURE__*/_createElementVNode("span", { class: "p-1" }, null, -1)
const _hoisted_76 = { class: "col-md-3" }
const _hoisted_77 = /*#__PURE__*/_createElementVNode("span", { class: "p-1" }, null, -1)
const _hoisted_78 = {
  key: 3,
  class: "row mb-3"
}
const _hoisted_79 = { class: "col-md-12" }
const _hoisted_80 = { class: "p-4" }
const _hoisted_81 = {
  key: 4,
  class: "row mb-3"
}
const _hoisted_82 = { class: "col-md-12" }
const _hoisted_83 = /*#__PURE__*/_createElementVNode("p", null, " Do you want to create a new company report from previous report? ", -1)
const _hoisted_84 = {
  key: 0,
  class: "pi pi-check text-success"
}
const _hoisted_85 = {
  key: 1,
  class: "pi pi-times text-danger"
}
const _hoisted_86 = /*#__PURE__*/_createElementVNode("span", { class: "p-1" }, null, -1)
const _hoisted_87 = { key: 0 }
const _hoisted_88 = { key: 1 }
const _hoisted_89 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_90 = /*#__PURE__*/_createElementVNode("p", null, " The system is calculating, please do not refresh the page or close the window while calculating. ", -1)
const _hoisted_91 = { class: "d-flex" }
const _hoisted_92 = { class: "p-row-title-text" }
const _hoisted_93 = /*#__PURE__*/_createElementVNode("div", {
  class: "align-items-center my-2",
  style: {"color":"red"}
}, "Please download the error list to review the issues.", -1)
const _hoisted_94 = { class: "row" }
const _hoisted_95 = { class: "col-md-12 d-flex" }
const _hoisted_96 = {
  key: 0,
  class: "col-md-12 mt-3"
}
const _hoisted_97 = { class: "d-flex justify-content-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TheHeader = _resolveComponent("TheHeader")!
  const _component_TheSidebar = _resolveComponent("TheSidebar")!
  const _component_ThePageLoading = _resolveComponent("ThePageLoading")!
  const _component_ThePageHeader = _resolveComponent("ThePageHeader")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_Divider = _resolveComponent("Divider")!
  const _component_Badge = _resolveComponent("Badge")!
  const _component_Button = _resolveComponent("Button")!
  const _component_TheLoading = _resolveComponent("TheLoading")!
  const _component_InlineMessage = _resolveComponent("InlineMessage")!
  const _component_ThePageError = _resolveComponent("ThePageError")!
  const _component_TheFooter = _resolveComponent("TheFooter")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_Textarea = _resolveComponent("Textarea")!
  const _component_TheSheetsCommentsDialog = _resolveComponent("TheSheetsCommentsDialog")!
  const _component_TheSheetsDialog = _resolveComponent("TheSheetsDialog")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_TheHeader),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("form", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_TheSidebar),
            (_ctx.isPageLoading)
              ? (_openBlock(), _createBlock(_component_ThePageLoading, { key: 0 }))
              : _createCommentVNode("", true),
            (!_ctx.isPageLoading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createVNode(_component_ThePageHeader, {
                    onDeleteEvent: _ctx.deleteCompanyReport,
                    onImportEvent: _ctx.importFile,
                    onExportEvent: _ctx.exportFile,
                    renderDelete: (_ctx.companyReport.status != '' && (_ctx.isAdmin || _ctx.isHQStaff) && (_ctx.companyReport.status == 'Created' || _ctx.companyReport.status == 'Rejected')),
                    renderImport: (!_ctx.isViewer && (_ctx.companyReport.status == 'Created' || _ctx.companyReport.status == 'Rejected') ? true : false),
                    renderExport: (!_ctx.isViewer && _ctx.companyReport.status != '' ? true : false),
                    isDeleting: _ctx.isDeleting,
                    isImporting: _ctx.isImporting,
                    isExporting: _ctx.isExporting
                  }, null, 8, ["onDeleteEvent", "onImportEvent", "onExportEvent", "renderDelete", "renderImport", "renderExport", "isDeleting", "isImporting", "isExporting"]),
                  (_ctx.pageError == '')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, [
                          (_ctx.identifier != null)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                _hoisted_9,
                                _createElementVNode("div", _hoisted_10, [
                                  _createVNode(_component_InputText, {
                                    modelValue: _ctx.companyReport.fileId,
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.companyReport.fileId) = $event)),
                                    disabled: ""
                                  }, null, 8, ["modelValue"])
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_11, [
                            _hoisted_12,
                            (_ctx.companyReport.status == '' || _ctx.companyReport.status == null)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                  _createVNode(_component_Dropdown, {
                                    options: _ctx.companies,
                                    optionLabel: "code",
                                    optionValue: "identifier",
                                    filter: "",
                                    filterFields: ['code', 'name'],
                                    showClear: "",
                                    placeholder: _ctx.isCompanyLoading ? ('Loading...') : '-- Please Select --',
                                    loading: _ctx.isCompanyLoading,
                                    modelValue: _ctx.companyReport.company.identifier,
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.companyReport.company.identifier) = $event)),
                                    disabled: _ctx.identifier != null,
                                    onChange: _ctx.onCompanyChange
                                  }, {
                                    value: _withCtx((slotProps) => [
                                      (slotProps.value)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                            _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.filterCompanyCodeByValue(slotProps.value)), 1),
                                            _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.filterCompanyNameByValue(slotProps.value)), 1)
                                          ]))
                                        : (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(slotProps.placeholder), 1))
                                    ]),
                                    option: _withCtx((slotProps) => [
                                      _createElementVNode("div", _hoisted_18, [
                                        _createElementVNode("span", _hoisted_19, _toDisplayString(slotProps.option.code), 1),
                                        _createElementVNode("span", _hoisted_20, _toDisplayString(slotProps.option.name), 1)
                                      ])
                                    ]),
                                    _: 1
                                  }, 8, ["options", "placeholder", "loading", "modelValue", "disabled", "onChange"])
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                  _createVNode(_component_InputText, {
                                    class: "p-inputtext",
                                    type: "text",
                                    maxlength: "10",
                                    placeholder: "Company",
                                    modelValue: _ctx.companyReport.company.name,
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.companyReport.company.name) = $event)),
                                    disabled: _ctx.identifier != null
                                  }, null, 8, ["modelValue", "disabled"])
                                ]))
                          ]),
                          _createElementVNode("div", _hoisted_22, [
                            _hoisted_23,
                            _createElementVNode("div", _hoisted_24, [
                              _createVNode(_component_Calendar, {
                                dateFormat: "yy-mm-dd",
                                manualInput: true,
                                placeholder: "Balance Sheet Date",
                                modelValue: _ctx.companyReport.balanceSheetDate,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.companyReport.balanceSheetDate) = $event)),
                                disabled: _ctx.identifier != null
                              }, null, 8, ["modelValue", "disabled"])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_25, [
                            _hoisted_26,
                            _createElementVNode("div", _hoisted_27, [
                              _createVNode(_component_Dropdown, {
                                options: _ctx.currencies,
                                optionLabel: "code",
                                optionValue: "identifier",
                                filter: "",
                                filterFields: ['code', 'name'],
                                showClear: "",
                                placeholder: "-- Please Select --",
                                modelValue: _ctx.companyReport.currency.identifier,
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.companyReport.currency.identifier) = $event)),
                                disabled: _ctx.identifier != null
                              }, {
                                value: _withCtx((slotProps) => [
                                  (slotProps.value)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                                        _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.filterCurrencyCodeByValue(slotProps.value)), 1),
                                        _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.filterCurrencyNameByValue(slotProps.value)), 1)
                                      ]))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_31, _toDisplayString(slotProps.placeholder), 1))
                                ]),
                                option: _withCtx((slotProps) => [
                                  _createElementVNode("div", _hoisted_32, [
                                    _createElementVNode("span", _hoisted_33, _toDisplayString(slotProps.option.code), 1),
                                    _createElementVNode("span", _hoisted_34, _toDisplayString(slotProps.option.name), 1)
                                  ])
                                ]),
                                _: 1
                              }, 8, ["options", "modelValue", "disabled"])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_35, [
                            _hoisted_36,
                            _createElementVNode("div", _hoisted_37, [
                              _createVNode(_component_Dropdown, {
                                options: _ctx.purposes,
                                optionLabel: "name",
                                optionValue: "identifier",
                                filter: "",
                                showClear: "",
                                placeholder: "-- Please Select --",
                                modelValue: _ctx.companyReport.purpose.identifier,
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.companyReport.purpose.identifier) = $event)),
                                disabled: _ctx.identifier != null
                              }, null, 8, ["options", "modelValue", "disabled"])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_38, [
                            _hoisted_39,
                            _createElementVNode("div", _hoisted_40, [
                              _createVNode(_component_Checkbox, {
                                modelValue: _ctx.companyReport.isConsolidated,
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.companyReport.isConsolidated) = $event)),
                                binary: true,
                                disabled: _ctx.identifier != null
                              }, null, 8, ["modelValue", "disabled"])
                            ])
                          ]),
                          (_ctx.identifier != null)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                                _createElementVNode("div", _hoisted_42, [
                                  _createVNode(_component_Divider, { type: "solid" })
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.identifier != null)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                                _createElementVNode("div", _hoisted_44, [
                                  _hoisted_45,
                                  _createElementVNode("div", _hoisted_46, [
                                    _createVNode(_component_InputText, {
                                      class: "p-inputtext",
                                      type: "text",
                                      maxlength: "50",
                                      modelValue: _ctx.companyReport.createdBy,
                                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.companyReport.createdBy) = $event)),
                                      readonly: ""
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _hoisted_47,
                                  _createElementVNode("div", _hoisted_48, [
                                    _createVNode(_component_InputText, {
                                      class: "p-inputtext",
                                      type: "text",
                                      maxlength: "50",
                                      modelValue: _ctx.companyReport.createdDate,
                                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.companyReport.createdDate) = $event)),
                                      readonly: ""
                                    }, null, 8, ["modelValue"])
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_49, [
                                  _hoisted_50,
                                  _createElementVNode("div", _hoisted_51, [
                                    _createVNode(_component_InputText, {
                                      class: "p-inputtext",
                                      type: "text",
                                      maxlength: "50",
                                      modelValue: _ctx.companyReport.submissionBy,
                                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.companyReport.submissionBy) = $event)),
                                      readonly: ""
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _hoisted_52,
                                  _createElementVNode("div", _hoisted_53, [
                                    _createVNode(_component_InputText, {
                                      class: "p-inputtext",
                                      type: "text",
                                      maxlength: "50",
                                      modelValue: _ctx.companyReport.submissionDate,
                                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.companyReport.submissionDate) = $event)),
                                      readonly: ""
                                    }, null, 8, ["modelValue"])
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_54, [
                                  _createElementVNode("div", _hoisted_55, [
                                    _createElementVNode("label", _hoisted_56, _toDisplayString(_ctx.companyReport.status === 'Rejected' ? 'Rejected By:' : 'Accepted By:'), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_57, [
                                    _createVNode(_component_InputText, {
                                      class: "p-inputtext",
                                      type: "text",
                                      maxlength: "50",
                                      modelValue: _ctx.companyReportHistory.createdBy,
                                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.companyReportHistory.createdBy) = $event)),
                                      readonly: ""
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _createElementVNode("div", _hoisted_58, [
                                    _createElementVNode("label", _hoisted_59, _toDisplayString(_ctx.companyReport.status === 'Rejected' ? 'Rejected Date:' : 'Accepted Date:'), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_60, [
                                    _createVNode(_component_InputText, {
                                      class: "p-inputtext",
                                      type: "text",
                                      maxlength: "50",
                                      modelValue: _ctx.companyReportHistory.createdDate,
                                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.companyReportHistory.createdDate) = $event)),
                                      readonly: ""
                                    }, null, 8, ["modelValue"])
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_61, [
                                  _hoisted_62,
                                  _createElementVNode("div", _hoisted_63, [
                                    _createVNode(_component_Badge, {
                                      class: _normalizeClass(["mr-2", [_ctx.companyReport.status == 'Accepted' ? 'p-badge-success' : (_ctx.companyReport.status == 'Rejected' || _ctx.companyReport.status == 'Cancelled' ? 'p-badge-danger' : (_ctx.companyReport.status == 'Submitted' ? 'p-badge-primary' : 'p-badge-warning'))]]),
                                      value: _ctx.companyReport.status
                                    }, null, 8, ["class", "value"])
                                  ]),
                                  _hoisted_64,
                                  _createElementVNode("div", _hoisted_65, [
                                    _createVNode(_component_InputText, {
                                      class: "p-inputtext",
                                      type: "text",
                                      maxlength: "50",
                                      modelValue: _ctx.companyReport.templateVersion,
                                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.companyReport.templateVersion) = $event)),
                                      readonly: ""
                                    }, null, 8, ["modelValue"])
                                  ])
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_66, [
                            _createElementVNode("div", _hoisted_67, [
                              (_ctx.identifier == null)
                                ? (_openBlock(), _createBlock(_component_Button, {
                                    key: 0,
                                    class: "p-button-sm",
                                    disabled: _ctx.v$.companyReport.$invalid || _ctx.isLoading || (_ctx.identifier != null && _ctx.companyReport.status != 'Created'),
                                    onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.showSaveConfirmationDialog())),
                                    label: "Save"
                                  }, null, 8, ["disabled"]))
                                : _createCommentVNode("", true),
                              (_ctx.identifier != null)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_68))
                                : _createCommentVNode("", true),
                              (_ctx.identifier != null)
                                ? (_openBlock(), _createBlock(_component_Button, {
                                    key: 2,
                                    class: "p-button-sm p-button-warning",
                                    disabled: _ctx.isLoading || _ctx.isImporting || _ctx.isExporting || _ctx.isDeleting,
                                    onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.checkUnsaved(1))),
                                    label: "Open Sheets"
                                  }, null, 8, ["disabled"]))
                                : _createCommentVNode("", true),
                              _hoisted_69,
                              (_ctx.identifier != null)
                                ? (_openBlock(), _createBlock(_component_Button, {
                                    key: 3,
                                    class: "p-button-sm p-button-warning",
                                    disabled: _ctx.isLoading || _ctx.isImporting || _ctx.isExporting || _ctx.isDeleting,
                                    onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.showSheetsCommentsDialog())),
                                    label: "Comments"
                                  }, null, 8, ["disabled"]))
                                : _createCommentVNode("", true),
                              _hoisted_70,
                              (_ctx.identifier != null)
                                ? (_openBlock(), _createBlock(_component_Button, {
                                    key: 4,
                                    class: "p-button-sm",
                                    disabled: _ctx.v$.companyReport.$invalid || _ctx.isLoading || _ctx.isImporting || _ctx.isExporting || _ctx.isDeleting || (_ctx.identifier != null && _ctx.companyReport.status != 'Created' && _ctx.companyReport.status != 'Rejected'),
                                    hidden: _ctx.isViewer,
                                    onClick: _ctx.submit,
                                    label: "Submit"
                                  }, null, 8, ["disabled", "hidden", "onClick"]))
                                : _createCommentVNode("", true),
                              _hoisted_71,
                              (_ctx.identifier != null && (_ctx.companyReport.status == 'Submitted' || _ctx.companyReport.status == 'Accepted') && ((_ctx.isAdmin || _ctx.isHQStaff)))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
                                    _createVNode(_component_Button, {
                                      class: "p-button-sm p-button-danger",
                                      disabled: _ctx.isRPKLoaded,
                                      onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.reject(_ctx.companyReport, 'RPK'))),
                                      label: "Reject"
                                    }, null, 8, ["disabled"]),
                                    _hoisted_73,
                                    (_ctx.companyReport.status == 'Submitted')
                                      ? (_openBlock(), _createBlock(_component_Button, {
                                          key: 0,
                                          class: "p-button-sm p-button-success",
                                          onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.approve(_ctx.companyReport, 'RPK'))),
                                          label: "Accept"
                                        }))
                                      : _createCommentVNode("", true),
                                    (_ctx.companyReport.status == 'Submitted')
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_74))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true),
                              _createVNode(_component_Button, {
                                class: "p-button-sm p-button-secondary",
                                onClick: _ctx.backPreviousPage,
                                label: "Cancel"
                              }, null, 8, ["onClick"]),
                              _hoisted_75,
                              (_ctx.isLoading)
                                ? (_openBlock(), _createBlock(_component_TheLoading, { key: 6 }))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_76, [
                              (_ctx.identifier != null)
                                ? _withDirectives((_openBlock(), _createBlock(_component_Button, {
                                    key: 0,
                                    class: "p-button-sm p-button-warning",
                                    disabled: _ctx.isLoading || _ctx.isImporting || (_ctx.identifier != null && _ctx.companyReport.status != 'Created' && _ctx.companyReport.status != 'Rejected'),
                                    hidden: _ctx.isViewer,
                                    onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.calculate(1))),
                                    label: "Recalculate"
                                  }, null, 8, ["disabled", "hidden"])), [
                                    [
                                      _directive_tooltip,
                                      {value: 'Calculate Sheet Values'},
                                      void 0,
                                      { top: true }
                                    ]
                                  ])
                                : _createCommentVNode("", true),
                              _hoisted_77,
                              (_ctx.identifier != null)
                                ? _withDirectives((_openBlock(), _createBlock(_component_Button, {
                                    key: 1,
                                    class: "p-button-sm p-button-warning",
                                    disabled: _ctx.isLoading || _ctx.isImporting || _ctx.companyReport.isNearestThousand || (_ctx.identifier != null && _ctx.companyReport.status != 'Created' && _ctx.companyReport.status != 'Rejected'),
                                    hidden: _ctx.isViewer,
                                    onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.nearestThousandConversion(_ctx.companyReport))),
                                    label: "Convert"
                                  }, null, 8, ["disabled", "hidden"])), [
                                    [
                                      _directive_tooltip,
                                      {value: 'Convert Nearest Thousand'},
                                      void 0,
                                      { top: true }
                                    ]
                                  ])
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          (_ctx.identifier != null && _ctx.companyReportHistory.remarks != null && _ctx.companyReportHistory.remarks != '')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_78, [
                                _createElementVNode("div", _hoisted_79, [
                                  _createVNode(_component_InlineMessage, {
                                    severity: "warn",
                                    class: "d-block"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("Remarks: "),
                                      _createElementVNode("pre", _hoisted_80, _toDisplayString(_ctx.companyReportHistory.remarks), 1)
                                    ]),
                                    _: 1
                                  })
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.identifier != null && _ctx.isRPKLoaded)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_81, [
                                _createElementVNode("div", _hoisted_82, [
                                  _createVNode(_component_InlineMessage, {
                                    severity: "info",
                                    class: "d-block"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("RPK is currenly loaded in a CWK: " + _toDisplayString(_ctx.loadedInFileId), 1)
                                    ]),
                                    _: 1
                                  })
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.pageError != '')
                    ? (_openBlock(), _createBlock(_component_ThePageError, {
                        key: 1,
                        onBackEvent: _ctx.cancel,
                        pageError: _ctx.pageError
                      }, null, 8, ["onBackEvent", "pageError"]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            _createVNode(_component_TheFooter)
          ])
        ])
      ])
    ]),
    _createVNode(_component_Dialog, {
      visible: _ctx.isShowConfirmation,
      "onUpdate:visible": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.isShowConfirmation) = $event)),
      header: "Create from Previous Report",
      modal: "",
      style: { width: '50vw' }
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_Button, {
          label: "No",
          icon: "pi pi-times",
          onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.save(false))),
          text: ""
        }),
        _hoisted_86,
        _createVNode(_component_Button, {
          label: "Yes",
          icon: "pi pi-check",
          onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.save(true))),
          disabled: _ctx.v$.selectedReport.$invalid || _ctx.isLoading
        }, null, 8, ["disabled"])
      ]),
      default: _withCtx(() => [
        _hoisted_83,
        _createVNode(_component_DataTable, {
          class: "p-datatable p-component align-middle mb-0 w-12",
          value: _ctx.previousReports,
          selection: _ctx.selectedReport,
          "onUpdate:selection": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.selectedReport) = $event)),
          paginator: "",
          rows: 5
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Column, {
              style: {"width":"5%"},
              selectionMode: "single"
            }),
            _createVNode(_component_Column, {
              style: {"width":"35%"},
              field: "fileId",
              header: "File ID"
            }),
            _createVNode(_component_Column, {
              style: {"width":"30%"},
              field: "date",
              header: "Balance Sheet Date"
            }),
            _createVNode(_component_Column, {
              style: {"width":"30%","text-align":"center"},
              header: "Is Consolidated"
            }, {
              body: _withCtx((slotProps) => [
                (slotProps.data.isConsolidated)
                  ? (_openBlock(), _createElementBlock("i", _hoisted_84))
                  : (_openBlock(), _createElementBlock("i", _hoisted_85))
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["value", "selection"])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_Dialog, {
      visible: _ctx.isShowUnsavedConfirmation,
      "onUpdate:visible": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.isShowUnsavedConfirmation) = $event)),
      header: "Recover Unsaved Changes",
      modal: "",
      style: { width: '40vw' }
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_Button, {
          label: "No",
          icon: "pi pi-times",
          onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.sheets(1, false, null))),
          text: ""
        }),
        _createVNode(_component_Button, {
          label: "Yes",
          icon: "pi pi-check",
          onClick: _cache[26] || (_cache[26] = ($event: any) => (_ctx.sheets(1, true, null))),
          hidden: _ctx.isViewer
        }, null, 8, ["hidden"])
      ]),
      default: _withCtx(() => [
        (_ctx.isViewer)
          ? (_openBlock(), _createElementBlock("p", _hoisted_87, " Any data entered by you (as a viewer) will not be saved or processed "))
          : (_openBlock(), _createElementBlock("p", _hoisted_88, " Unsaved changes detected and available to recovery. Would you like to recover these changes now? "))
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_Dialog, {
      visible: _ctx.isShowGlobalFilterConfirmation,
      "onUpdate:visible": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.isShowGlobalFilterConfirmation) = $event)),
      header: "Filter in use",
      modal: "",
      style: { width: '40vw' }
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_Button, {
          label: "No",
          icon: "pi pi-times",
          onClick: _ctx.proceedWithResetGlobalFilter,
          text: ""
        }, null, 8, ["onClick"]),
        _createVNode(_component_Button, {
          label: "Yes",
          icon: "pi pi-check",
          onClick: _ctx.proceedGlobalFilterWarning
        }, null, 8, ["onClick"])
      ]),
      default: _withCtx(() => [
        _createElementVNode("p", null, [
          _createTextVNode(" Click “No” to clear the Filter and view all companies."),
          _hoisted_89,
          _createTextVNode(" Click “Yes” to view "),
          _createElementVNode("b", null, _toDisplayString(_ctx.selectedGlobalFilterName), 1),
          _createTextVNode(" and Subsidiary Companies. ")
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_Dialog, {
      visible: _ctx.isCalculating,
      "onUpdate:visible": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.isCalculating) = $event)),
      header: "Calculating",
      modal: "",
      style: { width: '40vw' },
      closable: false
    }, {
      footer: _withCtx(() => [
        (_ctx.isCalculating)
          ? (_openBlock(), _createBlock(_component_TheLoading, { key: 0 }))
          : _createCommentVNode("", true)
      ]),
      default: _withCtx(() => [
        _hoisted_90
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_Dialog, {
      visible: _ctx.isShowImportErrorNotification,
      "onUpdate:visible": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.isShowImportErrorNotification) = $event)),
      header: "Import Error Notification",
      modal: "",
      style: { width: '60vw' },
      closable: false
    }, {
      footer: _withCtx(() => [
        _hoisted_93,
        _createVNode(_component_Button, {
          label: "Download",
          icon: "pi pi-download",
          onClick: _cache[30] || (_cache[30] = ($event: any) => (_ctx.downloadImportError())),
          text: ""
        }),
        _createVNode(_component_Button, {
          label: "Ok",
          icon: "pi pi-times",
          onClick: _cache[31] || (_cache[31] = ($event: any) => (_ctx.loadSheetWithImportFile()))
        })
      ]),
      default: _withCtx(() => [
        _createElementVNode("p", null, " Import file " + _toDisplayString(_ctx.importFileName) + " completed with " + _toDisplayString(_ctx.importErrors.length) + " issue(s). The rows listed below were skipped; all other rows were imported. ", 1),
        _createVNode(_component_DataTable, {
          class: "p-datatable p-component align-middle mb-0 w-12",
          value: _ctx.importErrors,
          paginator: "",
          rows: 10
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Column, {
              style: {"width":"6%"},
              field: "",
              header: "#",
              class: "p-template-column-number"
            }, {
              body: _withCtx((slotProps) => [
                _createElementVNode("div", _hoisted_91, [
                  _createElementVNode("span", _hoisted_92, _toDisplayString(slotProps.index + 1), 1)
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_Column, {
              style: {"width":"38%"},
              field: "sheetName",
              header: "Sheet Name"
            }),
            _createVNode(_component_Column, {
              style: {"width":"10%"},
              field: "importValue",
              header: "Value"
            }),
            _createVNode(_component_Column, {
              style: {"width":"10%"},
              field: "cell",
              header: "Cell"
            }),
            _createVNode(_component_Column, {
              style: {"width":"36%"},
              field: "errorMessage",
              header: "Message"
            })
          ]),
          _: 1
        }, 8, ["value"])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_Dialog, {
      visible: _ctx.dialogRemark.visible,
      "onUpdate:visible": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.dialogRemark.visible) = $event)),
      header: "Confirmation",
      modal: "",
      style: {width: '40vw'}
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_97, [
          (this.dialogRemark.loading)
            ? (_openBlock(), _createBlock(_component_TheLoading, { key: 0 }))
            : _createCommentVNode("", true),
          _createVNode(_component_Button, {
            class: "p-button-text p-button-sm",
            label: "No",
            icon: "pi pi-times",
            onClick: _ctx.closeDialogRemark
          }, null, 8, ["onClick"]),
          _createVNode(_component_Button, {
            class: "p-button-sm",
            label: "Yes",
            icon: "pi pi-check",
            onClick: _ctx.onConfirmDialogRemark,
            disabled: (_ctx.dialogRemark.status == 'Rejected' && _ctx.dialogRemark.remarks == '')
          }, null, 8, ["onClick", "disabled"])
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_94, [
            _createElementVNode("div", _hoisted_95, [
              _createElementVNode("i", {
                class: _normalizeClass(["mr-3 align-self-center", _ctx.dialogRemark.icon != null && _ctx.dialogRemark.icon != '' ? _ctx.dialogRemark.icon : 'pi pi-exclamation-triangle']),
                style: {"font-size":"1.5rem"}
              }, null, 2),
              _createElementVNode("span", null, _toDisplayString(_ctx.dialogRemark.message), 1)
            ]),
            (_ctx.dialogRemark.withRemarks)
              ? (_openBlock(), _createElementBlock("div", _hoisted_96, [
                  _createVNode(_component_Textarea, {
                    modelValue: _ctx.dialogRemark.remarks,
                    "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.dialogRemark.remarks) = $event)),
                    autoResize: true,
                    rows: "5",
                    cols: "30",
                    maxlength: "255",
                    placeholder: "Remarks",
                    autofocus: ""
                  }, null, 8, ["modelValue"])
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_TheSheetsCommentsDialog, { ref: "sheetsCommentsDialog" }, null, 512),
    _createVNode(_component_TheSheetsDialog, {
      ref: "sheetDialog",
      identifier: _ctx.dialog.identifier,
      name: _ctx.dialog.companyName,
      companyId: _ctx.dialog.companyId,
      type: 'rpk',
      balanceSheetDate: _ctx.dialog.balanceSheetDate == null ? null : _ctx.formatToDate(_ctx.dialog.balanceSheetDate),
      currencyCode: _ctx.dialog.currencyCode,
      purpose: _ctx.dialog.purpose,
      id: _ctx.dialog.id,
      templateIndex: _ctx.dialog.templateIndex,
      status: _ctx.dialog.status,
      autoSaveFailed: _ctx.dialog.autoSaveFailed,
      visible: _ctx.dialog.visible,
      loading: _ctx.dialog.loading,
      isUnsaved: _ctx.dialog.isUnsaved,
      isConsolidated: _ctx.dialog.isConsolidated,
      reportSheets: _ctx.dialog.companyReportSheets,
      isNearestThousandPreview: _ctx.isNearestThousandPreview,
      onSave: _ctx.updateSheets,
      onAutoSave: _ctx.updateSheetCached,
      onDeleteCached: _ctx.deleteSheetCached,
      onCancel: _ctx.closeDialog
    }, null, 8, ["identifier", "name", "companyId", "balanceSheetDate", "currencyCode", "purpose", "id", "templateIndex", "status", "autoSaveFailed", "visible", "loading", "isUnsaved", "isConsolidated", "reportSheets", "isNearestThousandPreview", "onSave", "onAutoSave", "onDeleteCached", "onCancel"])
  ], 64))
}